import { render, staticRenderFns } from "./UserViewContent.vue?vue&type=template&id=648681dc"
import script from "./UserViewContent.vue?vue&type=script&lang=js"
export * from "./UserViewContent.vue?vue&type=script&lang=js"
import style0 from "./UserViewContent.vue?vue&type=style&index=0&id=648681dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports